// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"354":"c76cdef2","534":"2b91e554","566":"504623c1","774":"571ecee2","971":"4f3d3e15"}[chunkId] + ".css";
};